<template>
  <rd-column :size="$columns.TwelveOnLg">
    <rd-header
      :title="$t('dashboard.vinCustomReport.averageExpiration')"
      margins="none"
      size="medium"
    />
    <!-- <div class="row mb-1">
      <rd-form-group label="data od">
        <dx-date-box type="date" class="mr-1" @value-changed="onValueChanged" v-model="IssueDate" />
      </rd-form-group>
      <rd-form-group label="data do">
        <dx-date-box type="date" class="mr-1" @value-changed="onValueChanged" v-model="PaymentDueDate" />
      </rd-form-group> -->
    <!-- <rd-form-group label="Dział">
        <dx-lookup
                :search-enabled="true"
                :data-source="getDepartmentsDataSource"
                display-expr="Text"
                value-expr="Value"
                :closeOnOutsideClick="true"
                v-model="DepartmentId"
              >
              </dx-lookup>
      </rd-form-group>
      <rd-form-group label="Krok">
        <dx-lookup
                :search-enabled="true"
                :data-source="getStepsDataSource"
                display-expr="Text"
                value-expr="Value"
                :closeOnOutsideClick="true"
                v-model="DepartmentId"
              >
              </dx-lookup>
      </rd-form-group> -->
    <!-- </div> -->
    <div id="average-expiration-container" class="mt-2">
      <dx-data-grid
        :data-source="getVinAverageExpiration"
        :allow-column-resizing="true"
        :remote-operations="true"
        :show-borders="true"
        :row-alternation-enabled="true"
      >
        <dx-column data-field="ClientName" 
        :caption="$t('dashboard.clientName')"/>
        <dx-column
          data-field="AverageExpiration"
          :caption="$t('dashboard.averageExpiration')"
          sort-order="desc"
        />
        <dx-paging :page-size="50" />
        <dx-pager
          :show-page-size-selector="true"
          :allowed-page-sizes="[30, 50, 100]"
        />
        <dx-filter-row
          :visible="true"
          apply-filter="auto"
          :show-operation-chooser="false"
        />
        <dx-export
            :enabled="true"
            :file-name="getExportFileName"
        />
      </dx-data-grid>
    </div>
  </rd-column>
</template>

<script>
// @ is an alias to /src
//import Axios from 'axios';
//import router from 'vue-router';
//import sideNav from '../components/sideNav/Index'
import { mapFields } from "vuex-map-fields";
import { mapState, mapActions, mapGetters } from "vuex";
import commonMessages from "../../locales";
import localMessages from "../locales";
import {
  DxDataGrid,
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxExport
} from "devextreme-vue/data-grid";
import DxDateBox from "devextreme-vue/date-box";

const name = "processesStores/vinDashboardStores/indexStore";

export default {
  name: "VinAverageExpiration",
  created() {
    this.setVinAverageExpiration();
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(name, ["VinAverageExpiration"]),
    ...mapGetters(name, ["getVinAverageExpiration"]),
    getExportFileName(){
        return this.$t('dashboard.vinCustomReport.averageExpiration');
    }
  },
  methods: {
    ...mapActions(name, ["setVinAverageExpiration"]),
  },
  mounted() {},
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxPaging,
    DxPager,
    DxExport
  },
  i18n: {
    messages: localMessages.messages,
    sharedMessages: commonMessages.messages,
  },
};
</script>
